import { render, staticRenderFns } from "./ConversationsOptionsList.vue?vue&type=template&id=531080d5&scoped=true&"
import script from "./ConversationsOptionsList.vue?vue&type=script&lang=js&"
export * from "./ConversationsOptionsList.vue?vue&type=script&lang=js&"
import style0 from "./ConversationsOptionsList.vue?vue&type=style&index=0&id=531080d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531080d5",
  null
  
)

export default component.exports